
<template>
  <img class="lInfoImageB" @click="goBack" src="../../assets/image/team-bak.png" alt="">
</template>
<script>
export default {
  name:"MobileBak",
  props:{
    homeIndex:{
      type:Number,
      default(){
        return 0
      }
    }
  },
  methods:{
    goBack(){
      this.$store.dispatch('setStoreByKeyData',{key:'setFGoHome',data:this.homeIndex})
      this.$router.back()
    }
  }
}
</script>
<style scoped lang="scss">
.lInfoImageB{
  width: 1rem;
}
</style>
